import { CellOverlay, ImageBox, Point } from '@maxgraph/core';

/**
 * Approval Badge Overlay
 * Purple badge with checkmark/user icon
 */
export class ApprovalBadgeOverlay extends CellOverlay {
  readonly cellId: string;

  constructor(cellId: string, approvalCount: number = 1) {
    // Always show the icon, no count badge for now
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <text x="12" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-size="14" fill="#000">👤</text>
        </svg>`;
    // TODO: Uncomment below to show count badge
    // const svg = approvalCount > 1 
    //   ? `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    //       <text x="12" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-size="14" fill="#000">👤</text>
    //       <circle cx="22" cy="6" r="6" fill="#FF4444" stroke="white" stroke-width="1"/>
    //       <text x="22" y="11" text-anchor="middle" font-family="Arial,sans-serif" font-size="10" font-weight="bold" fill="white">${approvalCount}</text>
    //     </svg>`
    //   : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    //       <text x="12" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-size="14" fill="#000">👤</text>
    //     </svg>`;

    // Use data URI instead of blob URL for better compatibility
    // Encode SVG with UTF-8 support for emojis
    const utf8Svg = unescape(encodeURIComponent(svg));
    const dataUri = `data:image/svg+xml;base64,${btoa(utf8Svg)}`;
    const image = new ImageBox(dataUri, 24, 24);

    super(image, `${approvalCount} approver${approvalCount !== 1 ? 's' : ''}`, 'right', 'top');
    this.cellId = cellId;
    this.offset = new Point(-5, 5);
  }
}
